import React from "react";
import { Link } from "react-router-dom";

// Fable + wordmark: "Fable" in ink + accent-pink "+".
export function Logo({ className = "", onDark = false }) {
  return (
    <Link to="/" className={`inline-flex items-baseline gap-0.5 font-serif-display font-bold tracking-tight ${className}`}>
      <span className={onDark ? "text-white" : "text-foreground"}>Fable</span>
      <span style={{ color: "var(--fable)" }}>+</span>
    </Link>
  );
}
